import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";
import AdvertiserStatsOverview from "@/components/sales/AdvertiserStatsOverview";
import AdvertiserPipeline from "@/components/sales/AdvertiserPipeline";
import AdvertiserProspectForm from "@/components/sales/AdvertiserProspectForm";
import CampaignManager from "@/components/sales/CampaignManager";
import MediaKitBuilder from "@/components/sales/MediaKitBuilder";

const AdvertisersPage: React.FC = () => {
  const [showProspectForm, setShowProspectForm] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Advertisers Management</h1>
          <p className="text-muted-foreground mt-2">
            Manage advertising sales, campaigns, and media partnerships
          </p>
        </div>
        <Button onClick={() => setShowProspectForm(true)} className="gap-2">
          <PlusCircle className="h-4 w-4" />
          Add Prospect
        </Button>
      </div>

      <AdvertiserStatsOverview />

      <Tabs defaultValue="pipeline" className="space-y-6">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="pipeline">Sales Pipeline</TabsTrigger>
          <TabsTrigger value="campaigns">Active Campaigns</TabsTrigger>
          <TabsTrigger value="media-kit">Media Kit Builder</TabsTrigger>
          <TabsTrigger value="analytics">Performance Analytics</TabsTrigger>
        </TabsList>

        <TabsContent value="pipeline" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Advertising Sales Pipeline</CardTitle>
            </CardHeader>
            <CardContent>
              <AdvertiserPipeline />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="campaigns" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Campaign Management</CardTitle>
            </CardHeader>
            <CardContent>
              <CampaignManager />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="media-kit" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Media Kit & Proposal Builder</CardTitle>
            </CardHeader>
            <CardContent>
              <MediaKitBuilder />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="analytics" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Performance Analytics</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-center py-8 text-muted-foreground">
                Campaign performance analytics coming soon...
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>

      {showProspectForm && (
        <AdvertiserProspectForm 
          onClose={() => setShowProspectForm(false)}
          onSuccess={() => {
            setShowProspectForm(false);
            // Refresh data
          }}
        />
      )}
    </div>
  );
};

export default AdvertisersPage;